<template>
    <div id="submissionModule">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Soumission manuelle</h1>
            <input
                    type="file"
                    ref="importMobileFile"
                    name="importMobileFile"
                    class="form-control-file d-none"
                    v-on:change="importFile()"
            >
            <button
                    class="btn btn-custom"
                    @click="$refs.importMobileFile.click()"
            >
                Soumettre depuis un fichier mobile
            </button>
        </div>

        <div class="row mb-2">
            <div class="filter-bar ui basic segment grid ml-auto ">
                <div class="ui form row divResearch">
                    <input type="text" v-model="filterText" @keyup.enter="doFilter" placeholder="Rechercher..."
                           class="marginResearch">
                    <button class="btn btn-custom marginResearch" @click="doFilter">Rechercher</button>
                    <button class="btn btn-light" id="mlButtonAnnuler" @click="resetFilter">Annuler</button>

                </div>
            </div>
        </div>
        <div class="mb-3 background-alt">
            <div class="table-responsive">
                <vuetable ref="vuetable"
                          api-url="/api/trash_channels/table"
                          :fields="fields"

                          pagination-path=""
                          :append-params="moreParams"
                          :http-options="{ headers: { 'Authorization': 'Bearer ' + api_token }}"
                          @vuetable:pagination-data="onPaginationData"
                          class="table device-table"
                          no-data-template=""
                >

                    <div slot="code-slot" slot-scope="props">
                        {{ getInfringementCode(props.rowData.data) }}
                    </div>

                    <div slot="submit-slot" slot-scope="props">
                        <button class="btn-custom btn" @click="showSubmitModal(props.rowData)"
                                title="Re-soumettre"><i class="fas fa-redo"/></button>
                    </div>
                </vuetable>
            </div>

            <div class="row col-lg-12 pr-0">
                <div class="mr-auto">
                    <vuetable-pagination-info ref="paginationInfo"
                                              class="alert alert-info tablePagination"
                                              info-template="Affichage de {from} à {to} sur {total} Soumissions en erreur"
                                              no-data-template="Aucune soumission en erreur"
                    />
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                                         @vuetable-pagination:change-page="onChangePage"
                                         :css="css.pagination"
                    />
                </div>
            </div>

            <modal :showModal="showModal"  v-if="showModal" :hideModal="hideModal">
                <h5 slot="header">
                    Soumission manuelle
                </h5>

                <div slot="body" class="w-100">
                    <div>
                      <b>
                        <span v-if="infringementKey === 'session'">Session</span>
                        <span
                            v-else-if="infringementKey === 'control'">Contrôle
                        </span>
                        <span v-else>PV</span>
                       : </b>{{ infringementCode }}</div>
                    <div><b>Du :</b>
                      <span v-if="Array.isArray(infringementDate)">
                      {{ infringementDate[0] }} - {{ infringementDate[1] }}
                      </span>
                      <span v-else>
                        {{ infringementDate }}
                      </span>
                    </div>

                    <div><b>Statut TETT : </b><span><vue-element-loading class="ml-4" :active="tettStatus === null" color="#007bff" spinner="spinner"/>{{ tettStatus }}</span></div>
                    <div v-if="infringementKey !== 'session' && infringementKey !== 'control' "><b>Statut Tigre :
                    </b><span><vue-element-loading class="ml-4" :active="tettStatus === null" color="#007bff" spinner="spinner"/>{{ exportStatus }}</span></div>
                    <hr/>
                    <div class="form-group">
                        <label><b>XML :</b></label>
                        <template>
                            <prism-editor class="my-editor" v-model="xml" :highlight="highlighter" line-numbers></prism-editor>
                        </template>
                    </div>
                </div>

                <div slot="footer">
                    <button class="btn btn-custom"
                            :disabled="!submitAllowed || tettStatus === null" @click="submit">
                      <span v-if="loading">
                        Soumission en cours
                      </span>
                      <span v-else>
                        Valider
                      </span>
                    </button>
                    <button class="btn btn-danger" @click="hideModal">Fermer</button>
                </div>
            </modal>

        </div>

        <infringement-search-result-modal></infringement-search-result-modal>

    </div>
</template>

<script>

    import Vue from 'vue';
    import axios from 'axios';
    import Vuetable from 'vuetable-2';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
    import Swal from 'sweetalert2';
    import vkbeautify from 'vkbeautify';
    import Modal from './layout/Modal';
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";
    import parser from "fast-xml-parser";

    // import Prism Editor
    import { PrismEditor } from 'vue-prism-editor';
    import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

    // import highlighting library (you can use any library you want just return html string)
    import { highlight, languages } from 'prismjs/components/prism-core';
    import 'prismjs/components/prism-clike';
    import 'prismjs/components/prism-javascript';
    import 'prismjs/themes/prism-tomorrow.css';
    import VueElementLoading from "vue-element-loading"; // import syntax highlighting styles

    export default {
        components: {
            VueElementLoading,
            Vuetable, VuetablePagination, VuetablePaginationInfo, Modal, InfringementSearchResultModal, PrismEditor},
        computed: {
            api_token() {
                return api_token;
            }
        },
        data() {
            return {
                debug: '',
                filterText: '',
                showModal: false,
                moreParams: {},

                file: null,
                trashChannelId: null,

                infringementKey: null,
                infringementIntegrationMode: null,

                infringementCode: null,
                infringementDate: null,
                tettStatus: null,
                exportStatus: null,

                xml: null,

                submitAllowed: false,

                fields: [
                    {
                        name: 'key',
                        title: 'Type',
                    },
                    {
                        name: 'code-slot',
                        title: 'Numéro',
                    },
                    {
                        name: 'created_at',
                        title: 'Date',
                    },
                    {
                        name: 'submit-slot',
                        title: '',
                    },
                ],

                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                },

              loading: false
            }
        },
      methods: {
            async getFine(fineCode) {
                await axios.get('/api/fines/' + fineCode + '?isClientId=true')
                    .then(result => {
                        if (Object.keys(result.data).length) {
                            this.tettStatus = 'Existant';
                            this.exportStatus = result.data.exported === 0 ? 'Non soumis' : 'Soumis';
                            this.submitAllowed = false;
                        } else {
                            this.tettStatus = 'Inexistant';
                            this.exportStatus = 'Non soumis';
                            this.submitAllowed = true;
                        }
                    });
            },

            async getIf(ifCode) {
                await axios.get('/api/ifs/' + ifCode + '?isClientId=true')
                    .then(result => {
                        if (Object.keys(result.data).length) {
                            this.tettStatus = 'Existant';
                            this.exportStatus = result.data.exported === 0 ? 'Non soumis' : 'Soumis';
                            this.submitAllowed = false;
                        } else {
                            this.tettStatus = 'Inexistant';
                            this.exportStatus = 'Non soumis';
                            this.submitAllowed = true;
                        }
                    });
            },

            async getMercy(mercyCode) {
                await axios.get('/api/mercies/' + mercyCode + '?isClientId=true')
                    .then(result => {
                        this.tettStatus = '-';
                        this.exportStatus = '-';
                      if (Object.keys(result.data).length) {
                        this.tettStatus = 'Existant';
                        this.exportStatus = result.data.exported === 0 ? 'Non soumis' : 'Soumis';
                        this.submitAllowed = false;
                      } else {
                        this.tettStatus = 'Inexistant';
                        this.exportStatus = 'Non soumis';
                        this.submitAllowed = true;
                      }
                    });
            },

            async getControl(controlCode) {
                await axios.get('/api/controls/' + controlCode + '?isClientId=true')
                    .then(result => {
                        this.tettStatus = '-';
                        this.exportStatus = '-';
                        if (Object.keys(result.data).length) {
                            this.tettStatus = 'Existant';
                            this.exportStatus = result.data.exported === 0 ? 'Non soumis' : 'Soumis';
                            this.submitAllowed = false;
                        } else {
                            this.tettStatus = 'Inexistant';
                            this.exportStatus = 'Non soumis';
                            this.submitAllowed = true;
                        }
                    });
            },

            async getSession(controlCode) {
                await axios.get('/api/sessions/' + controlCode + '?isClientId=true')
                    .then(result => {
                        this.tettStatus = '-';
                        this.exportStatus = '-';
                        if (Object.keys(result.data).length) {
                          this.tettStatus = 'Existant';
                          this.exportStatus = result.data.exported === 0 ? 'Non soumis' : 'Soumis';
                          this.submitAllowed = false;
                        } else {
                          this.tettStatus = 'Inexistant';
                          this.exportStatus = 'Non soumis';
                          this.submitAllowed = true;                        }
                    });
            },

            submitInfringement(url, cipheredMessage) {
                axios.post(url,{data: cipheredMessage}, {
                  headers:
                      {
                        "X-integration-mode": this.infringementIntegrationMode
                      }
                }
                )
                    .then((success) => {
                        if (this.infringementIntegrationMode === 2) {
                            axios.delete('/api/trash_channels/' + this.trashChannelId).then(() => {
                              this.$refs.vuetable.refresh()
                            });
                        }
                        this.hideModal();
                        Swal({
                            type: 'success',
                            text: 'Soumission effectuée avec succès'
                        });
                    }).catch((error) => {
                        let errorData = error.response.data;
                        delete errorData['trace'];
                        let swalText = '';
                        if (typeof errorData['message'] !== 'undefined' && errorData['message'].includes('simplexml_load_string')) {
                            swalText = 'XML mal formé';
                        } else {
                            for (let [errorKey, errorValue] of Object.entries(errorData)) {
                                swalText += '<b>' + errorKey + ' : </b>' + errorValue + '<br/>';
                            }
                        }
                        Swal({
                            type: 'error',
                            title: 'Une erreur est survenue',
                            html: swalText
                        });
                }).finally(() => {
                  this.loading = false
                  this.submitAllowed = true
                });
            },

            highlighter(code) {
                return highlight(code, languages.js); //returns html
            },

            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            importFile() {
                this.file = this.$refs.importMobileFile.files[0];
                this.importInProgress = true;
                this.createFileReader();this.importInProgress = false;
                this.infringementIntegrationMode = 1;
                this.showModal = true;
            },

            createFileReader() {
                let reader = new FileReader();
                reader.onload = () => {
                    axios.post('/api/logs/decipher',{messageToDecipher: reader.result})
                        .then(result => {
                            this.populateSubmitData(result.data)
                        });
                };
                reader.readAsText(this.file);
            },

            doFilter() {
                this.moreParams = {
                    'filter': this.filterText
                };
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },

            resetFilter() {
                this.moreParams = {};
                this.filterText = '';
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },

            hideModal() {
                // We clear the last chosen file reference to permit at the next time the trigger of the change event on the file input even if we select the same file
                this.$refs.importMobileFile.value = null;
                this.showModal = false;
            },

            getInfringementCode(xmlInfringement) {
                const jsonInfringement = this.getJsonInfringement(xmlInfringement);
                const key = this.setInfringementKey(jsonInfringement);
                if (key === 'session'){
                  return jsonInfringement[key]['session_id']
                }
                return jsonInfringement[key]['id'];
            },

            getJsonInfringement(xmlInfringement) {
                return parser.parse(xmlInfringement)['smg'];
            },

            setInfringementKey(jsonInfringement) {
                if (typeof jsonInfringement['fine'] !== 'undefined') {
                   return 'fine';
                } else if (typeof jsonInfringement['if'] !== 'undefined'){
                   return 'if';
                } else if (typeof jsonInfringement['mercy'] !== 'undefined'){
                   return 'mercy';
                } else if (typeof jsonInfringement['control'] !== 'undefined'){
                   return 'control';
                } else if (typeof jsonInfringement['session'] !== 'undefined'){
                   return 'session';
                }
            },

            setInfringementModalInfos() {
                if (this.infringementKey === 'fine') {
                    this.getFine(this.infringementCode);
                } else if (this.infringementKey === 'if') {
                    this.getIf(this.infringementCode);
                } else if (this.infringementKey === 'mercy') {
                    this.getMercy(this.infringementCode);
                } else if (this.infringementKey === 'control') {
                    this.getControl(this.infringementCode);
                } else if (this.infringementKey === 'session') {
                    this.getSession(this.infringementCode);
                }
            },

            showSubmitModal(trashChannelModel) {
                this.trashChannelId = trashChannelModel.id;
                this.infringementIntegrationMode = 2;
                this.populateSubmitData(trashChannelModel.data)
                this.showModal = true;
            },

            populateSubmitData(xml) {
                const jsonInfringement = this.getJsonInfringement(xml);
                this.setInfringementKey(jsonInfringement);
                this.infringementKey = this.setInfringementKey(jsonInfringement)
                this.infringementCode = this.setInfringementCode(jsonInfringement);
                this.infringementDate = this.setInfringementDate(jsonInfringement);
                this.setInfringementModalInfos();
                this.xml = vkbeautify.xml(xml);
            },
            setInfringementCode(data){
              if (this.infringementKey === 'session'){
                return data[this.infringementKey]['session_id']
              }
              return data[this.infringementKey]['id']
            },
            setInfringementDate(data){
              if (this.infringementKey === 'session'){
                return[
                    data[this.infringementKey]['session_start'],
                    data[this.infringementKey]['session_start']
                ]
              }
              return data[this.infringementKey]['date_time']
            },

            submit() {
              this.loading = true
              this.submitAllowed = false
              axios.post('/api/logs/cipher',{messageToCipher: this.xml})
                    .then(async (success) =>  {
                        let cipheredMessage = success.data;
                        if (this.infringementKey === 'fine') {
                            await this.submitInfringement('/api/fines', cipheredMessage);
                        } else if (this.infringementKey === 'if') {
                            await this.submitInfringement('/api/ifs', cipheredMessage);
                        } else if (this.infringementKey === 'mercy') {
                            await this.submitInfringement('/api/mercies', cipheredMessage);
                        } else if (this.infringementKey === 'control') {
                            await this.submitInfringement('/api/controls', cipheredMessage);
                        } else if (this.infringementKey === 'session') {
                            await this.submitInfringement('/api/sessions', cipheredMessage);
                        }
                    })
            }
        },
    }
</script>

<style scoped>

    #mlButtonAnnuler {
        margin-right: 20px;
    }

    .marginResearch {
        margin-right: 10px;
    }

    .divResearch {
        margin-right: -5px;
    }

</style>

<style>
    .device-table td,
    .device-table thead th{
        vertical-align: middle !important;
        text-align: center !important;
    }

    #submissionModule .modal-dialog {
        max-width: 1024px !important;
    }

    #submissionModule .modal-body {
        height: 500px !important;
    }

    /* required class */
    .my-editor {
        /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
        background: #ffffff;
        color: #ccc;

        /* you must provide font-family font-size line-height. Example: */
        font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
        font-size: 14px;
        line-height: 1.5;
        padding: 5px;
    }

    /* optional class for removing the outline */
    .prism-editor__textarea:focus {
        outline: none;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/Submission.vue